/**
 * Created by Viacheslav Stepanian on 09.10.2026
 */

const MiniPromoToolbarItem = function () {
    ToolbarItem.call(this, ToolbarItem.MINI_PROMO);

    this.enable();
};

MiniPromoToolbarItem.prototype = Object.create(ToolbarItem.prototype);
MiniPromoToolbarItem.prototype.constructor = MiniPromoToolbarItem;

MiniPromoToolbarItem.prototype.isVisible = function () {
    return Boolean(cleverapps.miniPromo.getToolbarIcon())
        && cleverapps.miniPromo.isAvailable()
        && cleverapps.environment.isMainScene();
};

MiniPromoToolbarItem.prototype.onClick = function () {
    cleverapps.miniPromo.toggle();
};

ToolbarItem.MINI_PROMO = {
    type: 20,
    icon: function () {
        return cleverapps.miniPromo.getToolbarIcon();
    }
};
